import React, { useState } from 'react';
import Modal from 'react-modal';
import {
  CallbackButton,
  FormContainer,
  ModalCrossbtn,
  PopupContainer,
} from './styled';
import { images } from '../../Constants/ImageUrls';
import { scrollableBottomSheet } from '../../Utils/redirections';
import Text from './FieldTypes/Text';
import { saveFormData } from '../../datafetchers/productPage';
import { SnackBar } from '../Product/PdpHeader/styled';

function FormBottomPopUp(props) {
  const { element, productId, productData } = props;
  const formQuestions = element?.serviceFormData?.questions?.sort(
    (a, b) => a.priority - b.priority,
  );
  const [openFormPopUp, setOpenFormPopUp] = useState(false);
  const [showSnackbar, setShowSnackbar] = useState('');

  const handleClose = () => {
    setOpenFormPopUp(false);
  };

  const BottomStylePopup = scrollableBottomSheet('', '', '-100px', '', 'auto');

  const renderFormField = (question, index) => {
    switch (question.type) {
      case '1':
        return <Text key={index} element={question} index={index} />;
    }
  };

  const submitForm = async () => {
    if (
      formQuestions?.some(
        (question) =>
          question.errorMsg ||
          (!question.answer_text && question.required == '1'),
      )
    ) {
      showSnackbarMessage('Please fill all the required fields');
    } else {
      const body = {
        form_id: element?.serviceFormData?.form?.id,
        sku_id: productId,
        sku_name: productData?.nickname,
        form_response: formQuestions,
      };
      await saveFormData(body);
      setOpenFormPopUp(false);
      showSnackbarMessage(
        'Form Submitted Successfully. An expert will contact you within two working days.',
      );
      formQuestions.forEach((question) => {
        question.answer_text = '';
        question.errorMsg = '';
      });
    }
  };

  const showSnackbarMessage = (message) => {
    setShowSnackbar(message);
    setTimeout(() => {
      setShowSnackbar('');
    }, 2500);
  };

  return (
    <>
      <div
        onClick={() => {
          setOpenFormPopUp(true);
        }}
        style={{ cursor: 'pointer' }}
      >
        <img src={element?.image} alt="Form" width="100%" />
      </div>
      <Modal
        isOpen={openFormPopUp}
        onRequestClose={handleClose}
        style={BottomStylePopup}
        preventScroll={true}
        bodyOpenClassName="noScroll"
        htmlOpenClassName="noScroll"
        closeTimeoutMS={500}
        className={{
          base: 'bottomSheetProductPdp',
          afterOpen: 'bottomSheetProductOpen',
          beforeClose: 'bottomSheetProductClose',
        }}
      >
        <ModalCrossbtn src={images.blackCross} onClick={handleClose} />
        <PopupContainer>
          <div>
            <div className="heading">
              <img
                src="https://images.myloapp.in/NestJsUploads/1738820216436-need_help.svg"
                width={60}
                height={60}
                alt="Need Help"
              />
              <h5>{element?.serviceFormData?.description}</h5>
            </div>
            <FormContainer>
              {formQuestions?.map((question, index) => {
                return renderFormField(question, index);
              })}
            </FormContainer>
          </div>
          <CallbackButton onClick={submitForm}>
            Request a callback
          </CallbackButton>
        </PopupContainer>
      </Modal>
      <SnackBar className={showSnackbar ? 'show' : ''}>{showSnackbar}</SnackBar>
    </>
  );
}

export default FormBottomPopUp;
